import { useAuthInfo } from "@propelauth/react";
import { useEffect, useRef, useState } from "react";
import { BidBaseModel } from "./bidding_model";
import { useParams } from "react-router-dom";
import { fetchWithToken } from "../../api/apiBase";

import { CompanyBase } from "../../models/company";
import { moneyFormatter } from "../../lib/formatters";
import "chartjs-adapter-date-fns";
import { enUS } from "date-fns/locale";
import {
    Chart as ChartJS,
    CategoryScale,
    LinearScale,
    PointElement,
    LineElement,
    Title,
    Tooltip,
    Legend,
    TimeScale,
    Filler,
} from "chart.js";
import { Line } from "react-chartjs-2";
import zoomPlugin from "chartjs-plugin-zoom";
import { Button } from "../ui/button";
import { useNavigate } from "react-router-dom";
import BidChartInfo from "./BidChartInfo";
import {array} from "zod";

ChartJS.register(
    CategoryScale,
    LinearScale,
    PointElement,
    LineElement,
    Title,
    Tooltip,
    Legend,
    zoomPlugin,
    TimeScale,
    Filler
);

interface BidChartItem {
    id: string;
    bid_amount: number;
    submitted_at: Date;
}

interface BidChartCoItem extends BidChartItem {
    company: string;
    date: Date;
}

export interface BidChartGroup {
    company: CompanyBase;
    bids: BidChartItem[];
}

interface ChartData {
    labels: string[];
    datasets: {
        label: string;
        data: number[];
        borderColor: string;
        backgroundColor: string;
        tension: number;
    }[];
}

type BidChartProps = {
    project_id?: string;
    height?: string;
    isOnHomePage?: boolean;
    title?: string | null;
};

const predefinedColors = [
    "#728a8c",
    "#bfaf78",
    "#769ecf",
    "#a87ce6",
    "#76c4a9",
];



  // function convexHull(
    //     points: { x: number; y: number }[]
    // ): { x: number; y: number }[] {
    //     // console.log("Before sorting:", points);
    //
    //     points.sort((a, b) => (a.x === b.x ? a.y - b.y : a.x - b.x));
    //     // console.log("After sorting:", points);
    //
    //     function cross(
    //         o: { x: number; y: number },
    //         a: { x: number; y: number },
    //         b: { x: number; y: number }
    //     ): number {
    //         return (a.x - o.x) * (b.y - o.y) - (a.y - o.y) * (b.x - o.x);
    //     }
    //
    //     let lower: { x: number; y: number }[] = [];
    //     for (let p of points) {
    //         while (
    //             lower.length >= 2 &&
    //             cross(lower[lower.length - 2], lower[lower.length - 1], p) <= 0
    //         ) {
    //             lower.pop();
    //         }
    //         lower.push(p);
    //     }
    //
    //     let upper: { x: number; y: number }[] = [];
    //     for (let i = points.length - 1; i >= 0; i--) {
    //         while (
    //             upper.length >= 2 &&
    //             cross(
    //                 upper[upper.length - 2],
    //                 upper[upper.length - 1],
    //                 points[i]
    //             ) <= 0
    //         ) {
    //             upper.pop();
    //         }
    //         upper.push(points[i]);
    //     }
    //
    //     lower.pop();
    //     upper.pop();
    //
    //     // console.log("Lower hull:", lower);
    //     // console.log("Upper hull:", upper);
    //
    //     return [...lower, ...upper];
    // }
function getRandomPointStyle(companyName: string) {
    const hash = Array.from(companyName).reduce(
        (acc, char) => acc + char.charCodeAt(0),
        0
    );
    const styles = ["circle", "rect", "triangle", "star"];
    return styles[hash % styles.length];
}

const getCompanyColor = (companyName: string) => {
    const hash = Array.from(companyName).reduce(
        (acc, char) => acc + char.charCodeAt(0),
        0
    );
    return predefinedColors[hash % predefinedColors.length];
};


function makeChartHull2(sorteddata: BidChartCoItem[]) {
    let latest_bids: { [id: string] : BidChartCoItem; } = {}
    let low: BidChartCoItem = sorteddata[0];
    let high: BidChartCoItem = sorteddata[0];

    let upper = [];
    let lower = [];

    for (let i = 0; i < sorteddata.length;  i++) {

        let bid = sorteddata[i]
        // if (!(bid.company in latest_bids)){
        //     latest_bids[bid.company] = bid
        // } else {
        //
        // }

        if(bid.bid_amount > high.bid_amount){
            //
            high = bid;
            if(low && low.company === bid.company){

                // if new_high was previously low, find next low and reset
                low = Object.values(latest_bids).reduce((best: BidChartCoItem, current) => {
                   return current.bid_amount < best.bid_amount ? current : best;
                  });
            }
        }

        if(bid.bid_amount < low.bid_amount){
            //
            low = bid;
            if(high && high.company === bid.company){

                // if new_low was previously high, find next high and reset
                high = Object.values(latest_bids).reduce((best: BidChartCoItem, current) => {
                   return current.bid_amount > best.bid_amount ? current : best;
                  });
            }
        }
        // add points if needed
        // if(upper.length === 0 || upper[upper.length-1].y !== high.bid_amount){
            upper.push({x: new Date(bid.submitted_at), y:high.bid_amount, pointStyle: "circle", id: null})
         //}
        //if( lower.length === 0 || lower[lower.length-1].y !== low.bid_amount){
            lower.push({x: new Date(bid.submitted_at), y:low.bid_amount , pointStyle: "circle", id: null})
      //   }
        // cleanup
        latest_bids[bid.company] = bid
    }

    // const hull = lower.concat(upper);
    // hull.sort((a, b) => a.x.getTime() - b.x.getTime())
    return [lower, upper];
}


function BidChart(props: BidChartProps) {
    const { accessToken } = useAuthInfo();
    const [bids, setBids] = useState<BidChartGroup[] | null>(null);
    const { project_id: paramProjectId } = useParams<{ project_id: string }>();
    const [project_id, setProjectId] = useState<string>();
    const chartRef = useRef<any>(null);
    const navigate = useNavigate();

    useEffect(() => {
        const id = props.project_id || paramProjectId;

        if (id) {
            setProjectId(id);
        } else {
            return;
        }
    }, [props.project_id, paramProjectId]);

    useEffect(() => {
        if (!project_id) return
        fetchWithToken(
            `/projects/${project_id}/bidding-chart`,
            accessToken as string
        )
            .then((data: BidChartGroup[]) => {
                setBids(data);
            })
            .catch((err) => {
                console.log(err);
            });
    }, [project_id]);

    if (!bids) {
        return <></>;
    }
    const formattedData = bids
        .map((group) =>
            group.bids.map((bid) => ({
                company: group.company.name,
                bid_amount: bid.bid_amount,
                date: new Date(bid.submitted_at),
                id: (bid as any)._id,
            }))
        )
        .flat();

    const finalData = formattedData.map((bid) => ({
        ...bid,
        date: bid.date.toLocaleDateString("en-US", {
            year: "numeric",
            month: "short",
            day: "numeric",
        }),
    }));

    const groupedData = finalData.reduce((acc: Record<string, any[]>, bid) => {
        if (!acc[bid.company]) {
            acc[bid.company] = [];
        }
        acc[bid.company].push(bid);
        return acc;
    }, {} as Record<string, any[]>);

    const allPoints: BidChartCoItem[] =
        bids
    .reduce((acc: BidChartCoItem[], group) => {
        const companyPoints = group.bids.map((bid) => ({
            ...bid,
            submitted_at: new Date(bid.submitted_at),
            company:group.company.name
        }));
        // @ts-ignore
        return acc.concat(companyPoints)
    }, []).sort((a, b) => a.submitted_at.getTime()  - b.submitted_at.getTime() );


    const Ymin = allPoints.length ===0 ? 0 : allPoints.reduce((min, item) =>
        (item.bid_amount < min ? item.bid_amount : min), allPoints[0].bid_amount);
    const Ymax = allPoints.length ===0 ? 0 : allPoints.reduce((min, item) =>
        (item.bid_amount > min ? item.bid_amount : min), allPoints[0].bid_amount);
    const chartpoints = makeChartHull2(allPoints);

    const chartData = Object.keys(groupedData).map((companyName) => {
        const companyBids = groupedData[companyName];
        const color = getCompanyColor(companyName);
        const pointStyle = getRandomPointStyle(companyName);

        return {
            label: companyName,
            data: companyBids.map((bid) => ({
                x: new Date(bid.date),
                y: bid.bid_amount,
                id: bid.id as any,
                pointStyle: "rect",
            })),
            fill: false,
            borderColor: color,
            tension: 0.4,
            pointStyle: pointStyle,
            backgroundColor: color,
            pointRadius: 7,
            borderDash: [10, 5],
        };
    });

    //const sortedData = hull.sort((a, b) => a.x - b.x);

    // @ts-ignore
    // chartData.push({
    //     label: "Convex Hull",
    //     data: chartpoints[0],
    //         // @ts-ignore
    //     fill: '+1',
    //     backgroundColor: "rgba(255, 255, 0, 0.2)",
    //     borderColor: "transparent",
    //     borderDash: [0, 0],
    //     pointRadius: 0,
    //     tension: 0.4,
    //     pointStyle: "circle",
    // });
    // chartData.push({
    //     label: "Convex Hull",
    //     data: chartpoints[1],
    //     fill: false,
    //     backgroundColor: "rgba(255, 255, 0, 0.2)",
    //     borderColor: "transparent",
    //     borderDash: [0, 0],
    //     pointRadius: 0,
    //     tension: 0.4,
    //     pointStyle: "circle",
    // });
    // rgba(255, 255, 0, 0.2

    const options = {
        responsive: true,
        maintainAspectRatio: false,
        plugins: {
            legend: {
                position: "top" as "top",
                labels: {
                    generateLabels: (chart: any) => {
                        const datasets = chart.data.datasets;
                        return datasets
                            .filter((dataset: any) => dataset.label !== "Convex Hull"
                            )
                            .map((dataset: any, i: any) => ({
                                text: dataset.label,
                                fillStyle: dataset.borderColor,
                                hidden: !chart.isDatasetVisible(i),
                                strokeStyle: dataset.borderColor,
                                lineDash: [],
                                lineWidth: 0,
                            }));
                    },
                },
                onClick: (e: any) => {},
            },
            title: {
                display: props.title ? true : false,
                text: "Auction History",
            },
            zoom: {
                pan: {
                    enabled: true,
                    mode: "y" as "y",
                    speed: 10,
                    threshold: 10,
                },
                limits: {
                    x: {
                        min: 1000000,
                        max: 5000000,
                    },
                    y: {
                        min: Ymin - Ymin*.1,
                        max: Ymax + Ymax*.1,
                    },
                },
                zoom: {
                    wheel: {
                        enabled: true,
                        speed: 0.1,
                        animationDuration: 400,
                    },
                    pinch: {
                        enabled: true,
                        speed: 1,
                        animationDuration: 200,
                    },

                    mode: "y" as "y",
                },
            },
        },
        scales: {
            y: {
                type: "linear" as "linear",
                position: "left" as "left",
                beginAtZero: true,
                min: Ymin - Ymin*.1,
                ticks: {
                    stepSize: 5000000,
                    callback: function (value: any) {
                        if (props.isOnHomePage) {
                            return `$${(value / 1000000).toFixed(0)}m`
                        } else {
                            return moneyFormatter.format(value);
                        }
                    },
                },
            },

            x: {
                type: "time" as "time",
                time: {
                    unit: "day" as "day",
                    displayFormats: {
                        day: "MMM d, yyyy",
                    },
        
                },
                adapters: {
                    date: {
                        locale: enUS,
                    },
                },
                ticks: {
                    autoSkip: true,
                    maxTicksLimit: 3,
                    maxRotation: 45,
                    display: true,
                },
            },
        },
        onClick: (e: any, elements: any) => {
            if (elements.length > 0) {
                const element = elements[0];

                const datasetIndex = element.datasetIndex;
                const index = element.index;

                const chart = e.chart;
                const dataset = chart.config.data.datasets[datasetIndex];
                const pointData = dataset.data[index];
                const pointId = pointData.id;
                navigate(`/project/${project_id}/bid/${pointId}`);
            }
        },
    };

    const handleResetZoom = () => {
        if (chartRef.current) {
            chartRef.current.resetZoom();
        }
    };

    return (
        <>
            <div className={props.height || 'h-[400px]'}>
                <Line
                    ref={chartRef}
                    data={{ datasets: chartData }}
                    options={options}
                />
                {paramProjectId && <Button
                    className="mt-4"
                    type="button"
                    variant="outline"
                    onClick={handleResetZoom}
                >
                    Reset zoom
                </Button>}
                
            </div>
        </>
    );
}

export default BidChart;
